import React from "react";
import logo from "./../assets/img/logo.png";
import "./style.css";

const Footer = () => {
  return (
    <div className="microsite-footer">
      <img alt="logo" src={logo} />
    </div>
  );
};

export default Footer;
